"use strict";
/**
 * @class SVGCircleBadge
 * @description circle badge svg
 */
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BadgeLabel_1 = require("./BadgeLabel");
var SVGCircleBadge = function (_a) {
    var text = _a.text;
    return (React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", className: "oui__badge-circle" },
        React.createElement("circle", { cx: "50", cy: "50", r: "50" }),
        React.createElement(BadgeLabel_1.default, { text: text })));
};
exports.default = SVGCircleBadge;
//# sourceMappingURL=SVGCircleBadge.js.map